import type { Resource } from '../../';
export const header_utilBar_customerService: Resource = {"default":"Customer Service"};
